import React, { useCallback, useEffect, useState } from 'react';
import AppBarComponent from '../components/parts/appBar/AppBarComponent';
import { Snackbar, useMediaQuery, Button } from '@material-ui/core';
import LoadingComponent from '../components/LoadingComponent';
import FooterComponent from '../components/FooterComponent';
import { useRecoilState } from 'recoil';
import {
  additionalCostData,
  isLoggedIn,
  progressFlgState,
  workingBudgetData,
  workingBudgetInfo,
  workingBudgetsData,
  workingBudgetVendor,
  saveTimeStateData
} from '../GlobalState';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { ConstructsInfo } from '../components/workingBudget/ConstructsInfo';
import { WorkingBudget } from '../components/workingBudget/WorkingBudget';
import { ButtonArea } from '../components/workingBudget/ButtonArea';
import { EstimateBased } from '../components/workingBudget/EstimateBased';
import { AdditionalCost } from '../components/workingBudget/AdditionalCost';
import { TabArea } from '../components/workingBudget/TabArea';
import { BottomButton } from '../components/workingBudget/BottomButton';
import { CheckDisplay } from '../components/workingBudget/CheckDisplay';
import {
  checkReqData,
  getWorkingBudgetData,
  recalculation,
  updateWorkingBudgetData
} from '../utils/WorkingBudgetPage';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { TTopicPathState } from '../components/topicPath/type/Type';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import {
  NOT_LOGGED_IN,
  LOCAL_STORAGE_SAVE_TIME,
  LOCAL_WORKING_BUDGET_KEY,
  LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY
} from '../const/Const';
import { AlertModal } from '../components/editEstimates/AlertModal';

export const WorkingBudgetPage: React.FC = () => {
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  const workingBudgetId = Number(query.get('id') as string);

  const classes = useStyles();
  const matches2 = useMediaQuery('(min-width:900px)');

  const [workingBudget, setWorkingBudget] = useRecoilState(workingBudgetData);
  const [vendor, setVendor] = useRecoilState(workingBudgetVendor);
  const [additionalCost, setAdditionalCost] =
    useRecoilState(additionalCostData);
  const [saveTimeState, setSaveTimeState] = useRecoilState(saveTimeStateData);
  const [totallingInfo, setTotallingInfo] = useRecoilState(workingBudgetInfo);
  const [, setLoggedIn] = useRecoilState(isLoggedIn);
  const [open, setOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [isDetailShow, setIsDetailShow] = useState<boolean>(false);
  const [selectTab, setSelectTab] = useState<number>(0);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [, setProgressFlg] = useRecoilState<boolean>(progressFlgState);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  // ローカルストレージの内容を反映するかの確認モーダルの表示フラグ
  const [reflectModal, setReflectModal] = useState<boolean>(false);
  // 保存時間
  const [saveTime, setSaveTime] = useState<string | null>('');
  const [reflectData, setReflectData] = useState<boolean>(false);
  const history: any = useHistory();
  const params: any = useParams();

  const setKey = params.id
    ? LOCAL_WORKING_BUDGET_KEY + params.id
    : LOCAL_STORAGE_NEW_WORKING_BUDGET_KEY + workingBudgetId;

  function Alert(props: AlertProps) {
    return <MuiAlert elevation={6} variant='filled' {...props} />;
  }

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const handleCloseSuccess = (
    event?: React.SyntheticEvent,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSuccess(false);
  };

  useEffect(() => {
    setLoading(true);
    getWorkingBudgetData(
      workingBudgetId,
      changeLoggedInData,
      setErrorMessage,
      setOpen,
      setWorkingBudget,
      setVendor,
      setAdditionalCost
    ).finally(() => setLoading(false));
  }, []);

  const onSubmit = async () => {
    setProgressFlg(true);
    if (workingBudget) {
      updateWorkingBudgetData(
        workingBudget,
        additionalCost,
        vendor,
        totallingInfo,
        workingBudgetId,
        changeLoggedInData,
        setErrorMessage,
        setOpen,
        setSuccessMessage,
        setOpenSuccess,
        setWorkingBudget,
        setVendor,
        setAdditionalCost,
        false
      ).finally(() => setProgressFlg(false));
    }
    // ローカルストレージのデータを削除
    localStorage.removeItem(setKey);
    // 保存時間をリセット
    setSaveTime('');
  };

  useEffect(() => {
    // ローカルストレージデータ取得
    const localStorageData = localStorage.getItem(setKey);
    // データが存在する場合
    if (localStorageData) {
      // データをjsonへ変換
      const jsonData = JSON.parse(localStorageData);

      // 現在時間と保存時間の差分を計算(ms)
      const ms = new Date().getTime() - new Date(jsonData.time).getTime();
      // 時間に変換
      const hour = Math.floor(ms / 3600000);

      // 保存時間
      let saveTime = jsonData.time;

      // 24時間以上経過している場合
      if (LOCAL_STORAGE_SAVE_TIME <= hour) {
        // 保存時間を空文字で初期化
        saveTime = '';
        // ローカルストレージのデータを削除
        localStorage.removeItem(setKey);
      }

      // 保存時間を設定
      setSaveTime(saveTime);
    }
  }, [saveTimeState]);

  /**
   * ローカルストレージの内容を反映
   */
  const reflectLocalStorage = () => {
    setReflectData(true);
  };

  // パンくずリスト用に検索パラメーターを設定
  const patternState: TTopicPathState = {};
  patternState['/working_budgets'] = history.location.state;

  return (
    <div style={{ backgroundColor: '#F5F5F5' }}>
      <AppBarComponent
        patternName='working_budget_edit'
        patternState={patternState}
      />
      {loading ? (
        <>
          <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
            <Alert onClose={handleClose} severity='error'>
              {errorMessage}
            </Alert>
          </Snackbar>
          <LoadingComponent />
        </>
      ) : (
        <div
          style={{
            overflow: 'hidden',
            backgroundColor: '#F5F5F5',
            minHeight: window.innerHeight - 120
          }}
        >
          <div>
            <Snackbar open={open} autoHideDuration={4000} onClose={handleClose}>
              <Alert onClose={handleClose} severity='error'>
                {errorMessage}
              </Alert>
            </Snackbar>

            <Snackbar
              open={openSuccess}
              autoHideDuration={4000}
              onClose={handleCloseSuccess}
            >
              <Alert onClose={handleCloseSuccess} severity='success'>
                {successMessage}
              </Alert>
            </Snackbar>

            <div className={classes.titleArea}>
              <div style={{ fontWeight: 'bold' }}>
                <Button
                  style={{
                    minWidth: 90,
                    marginRight: 15,
                    color: '#758283',
                    backgroundColor: '#F5F5F5',
                    marginBottom: !matches2 ? 10 : 0
                  }}
                  variant='contained'
                  color='secondary'
                  onClick={() => {
                    //// 戻る先を判定する
                    if (history.location.state?.currentPage) {
                      history.push('/working-budgets', {
                        currentPage: history.location.state.currentPage
                      });
                    } else {
                      history.goBack();
                    }
                  }}
                  startIcon={<ArrowBackIcon />}
                >
                  戻る
                </Button>
              </div>
            </div>

            <div
              className='table-top-container-customer'
              style={{ display: 'flex' }}
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'baseline'
                }}
              >
                <div
                  style={{
                    fontWeight: 'bold',
                    padding: 15,
                    paddingBottom: 0,
                    fontSize: 24
                  }}
                >
                  実行予算編集
                </div>
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'baseline'
                }}
              >
                {saveTime && (
                  <>
                    <AlertModal
                      reflectModal={reflectModal}
                      setReflectModal={setReflectModal}
                      reflectLocalStorage={reflectLocalStorage}
                    />
                    <Button
                      style={{ color: '#0000FF', marginRight: 10 }}
                      onClick={() => {
                        setReflectModal(true);
                      }}
                    >{`最終保存：${saveTime}`}</Button>
                  </>
                )}
              </div>
            </div>

            {/*画面上部の情報エリア*/}
            <div className={classes.topArea}>
              <ConstructsInfo
                changeLoggedInData={changeLoggedInData}
                setErrorMessage={setErrorMessage}
                setOpen={setOpen}
                workingBudgetId={workingBudgetId}
              />
              <WorkingBudget
                workingBudgetId={workingBudgetId}
                changeLoggedInData={changeLoggedInData}
                setErrorMessage={setErrorMessage}
                setOpen={setOpen}
              />
            </div>

            {/*ボタンエリア*/}
            <div style={{ display: 'flex' }}>
              <TabArea selectTab={selectTab} setSelectTab={setSelectTab} />
              <ButtonArea
                changeLoggedInData={changeLoggedInData}
                setErrorMessage={setErrorMessage}
                setOpen={setOpen}
                setSuccessMessage={setSuccessMessage}
                setOpenSuccess={setOpenSuccess}
                workingBudgetId={workingBudgetId}
                DeleteButtonDisabled={
                  vendor && vendor.length > 0 ? false : true
                }
              />
            </div>

            <CheckDisplay
              isDetailShow={isDetailShow}
              setIsDetailShow={setIsDetailShow}
            />

            {selectTab == 0 && (
              <EstimateBased
                isDetailShow={isDetailShow}
                workingBudgetId={workingBudgetId}
                reflectData={reflectData}
              />
            )}
            {selectTab == 1 && (
              <AdditionalCost
                isDetailShow={isDetailShow}
                changeLoggedInData={changeLoggedInData}
                setErrorMessage={setErrorMessage}
                setOpen={setOpen}
                setSuccessMessage={setSuccessMessage}
                setOpenSuccess={setOpenSuccess}
                workingBudgetId={workingBudgetId}
                reflectData={reflectData}
              />
            )}

            <BottomButton onSubmit={onSubmit} />
          </div>
        </div>
      )}
      <FooterComponent />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    titleArea: {
      fontWeight: 'bold',
      padding: 15,
      paddingBottom: 0,
      fontSize: 24
    },
    topArea: {
      display: 'flex'
    },
    topList: {
      display: 'flex',
      marginTop: 25,
      marginBottom: 25,
      width: '100%',
      justifyContent: 'flex-start'
    },
    topBoxText: {
      fontSize: 14,
      color: '#000000'
    },
    selectTab: {
      backgroundColor: '#F5F5F5',
      borderTopColor: '#0099CB',
      borderBottom: 'none'
    },
    selectTopBoxText: {
      fontSize: 14,
      color: '#0099CB'
    }
  })
);
